import { Dayjs } from 'dayjs';

import { DATE_FORMATS } from '@src/constants';

export const checkSameYear = (data: Dayjs[][]) => {
  const showYear = !data[0][0].isSame(data[data.length - 1][1], 'year');

  return data.map(
    ([start]) =>
      start.format(DATE_FORMATS.MMM) + (showYear ? ' ' + start.year() : ''),
  );
};

export const is12HourFormat = () => {
  const format = new Intl.DateTimeFormat(navigator.language, {
    hour: 'numeric',
  }).resolvedOptions() as Intl.ResolvedDateTimeFormatOptions & {
    hourCycle?: string;
  };

  return format.hourCycle?.startsWith('h12') ?? false;
};
